<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="predictionList"
    item-key="id"
    :items-per-page="-1"
  >
    <template v-slot:top>
      <div class="pb-4">イベント参加中の予想</div>
    </template>  
  </v-data-table>
</template>

<script>
  import mixin from '@/util/mixin'

  export default {
    mixins: [mixin],
    data () {
      return {
        dialog: false,
        reason: '11',
        db: null,
        selected: [],
        headers: [
          {
            text: 'ID',
            align: 'start',
            sortable: false,
            value: 'id',
          },
          { text: '作成日時', value: 'createdAt' },
          { text: '更新日時', value: 'updatedAt' },
          { text: '締切日時', value: 'closeAt' },
          { text: '予想タイトル', value: 'predictionTitle' },
          { text: '予想本文', value: 'predictionBody' },
        ],
        predictionList: []
      }
    },
    methods: {
      getPredictionList () {
        this.$fb.getDocs(this.$fb.query(this.$fb.collection(this.$fb.firestore, 'event_prediction'),
          this.$fb.where('event_id', '==', 'FSIu1FnpQwqX0byQT1LQ'),
          this.$fb.limit(1000)))
          .then(eventPredictionSnap => {
            const predictionIdList = []
            eventPredictionSnap.forEach(eventPredictionDoc => {
              predictionIdList.push(eventPredictionDoc.data().prediction_id)
            })
            const predictionPromise = this.$fb.getDocs(this.$fb.query(this.$fb.collection(this.$fb.firestore, 'prediction')
                .withConverter(this.predictionConverter),
              this.$fb.orderBy('close_at', 'desc'),
              this.$fb.limit(1000)))
            const promiseArray = [
              predictionPromise,
            ]
            Promise.all(promiseArray).then(resultArray => {
              const predictionSnap = resultArray[0]
              this.predictionList = []
              predictionSnap.forEach(predictionDoc => {
                if (predictionIdList.includes(predictionDoc.id)) {
                  const predictionData = predictionDoc.data()
                  predictionData.createdAt = predictionData.createdAt.toLocaleString()
                  predictionData.updatedAt = predictionData.updatedAt.toLocaleString()
                  predictionData.closeAt = predictionData.closeAt.toLocaleString()
                  this.predictionList.push(predictionData)
                }
              })
            })
          }).catch(error => {
            console.error(error)
            this.rankList = []
          })
      },
    },
    created () {
      this.getPredictionList()
    }
  }
</script>